import React from 'react';
import PropTypes from 'prop-types';

export const IconInfoWhite = ({ className }) => (
  <svg className={className} width="28" height="29" viewBox="0 0 28 29" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle opacity="0.4" cx="10" cy="10" r="10" transform="matrix(-1 0 0 1 24 4.5)" fill="#C7D0E2" />
    <g clipPath="url(#clip0_566_15633)">
      <path
        d="M14.0012 20.3848C14.6512 20.3848 15.1781 19.8578 15.1781 19.2078V14.5C15.1781 13.8499 14.6512 13.323 14.0012 13.323C13.3512 13.323 12.8242 13.8499 12.8242 14.5V19.2078C12.8242 19.8578 13.3512 20.3848 14.0012 20.3848Z"
        fill="white"
      />
      <path
        d="M14.0012 10.9692C13.3512 10.9692 12.8242 10.4423 12.8242 9.79228C12.8242 9.14226 13.3512 8.61531 14.0012 8.61531H14.0125C14.6625 8.61531 15.1894 9.14226 15.1894 9.79228C15.1894 10.4423 14.6625 10.9692 14.0125 10.9692H14.0012Z"
        fill="white"
      />
    </g>
  </svg>
);

IconInfoWhite.propTypes = {
  className: PropTypes.string,
};

IconInfoWhite.defaultProps = {
  className: '',
};
